import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=7717d9e2&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=js"
export * from "./Limits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7717d9e2",
  null
  
)

export default component.exports